/* eslint-disable i18next/no-literal-string */
import React from 'react';
import OrderHeader from '../orderHeader';
import OrderTable from '../orderTable';
import IAddress from '../../Model/addressType';

interface IAddPurchaseState {
  data: IOrder
  loading: boolean,
  calendar: boolean,
  date?: Date | Date[] | null,
  shippingForm: JSX.Element[],
  sensorsForm: JSX.Element[],
  rewardsForm: JSX.Element[]
}

interface IOrder {
  [key: string]: string | number | undefined | IAddress | any[],
  orderId?: string,
  email?: string,
  date?: string,
  billingAddress?: IAddress,
  shippingAddress?: IAddress,
  note?: string,
  lineItems?: any[],
  total?: number;
  name?: string,
  source?: string
}
interface Props {
  data: any
}
const OrderDetails = ({ data }: Props) => {
  // Fake data for test:
  const rowShippingInfo1 = {
    shippingName: 'Derek Dainys',
    shippingAddress: '12345 South Mallard Lane, Homer Glen',
    shippingContacts: [
      { email: 'derekdainys@gmail.com', phone: '1523888812' },
      { email: 'test@gmail.com', phone: '1522229999' }
    ]
  };

  const rowShippingInfo2 = {
    shippingName: 'Derek Dainys',
    shippingAddress: '12345 South Mallard Lane, Homer Glen',
    shippingContacts: [
      { email: 'derekdainys@gmail.com', phone: '1523888812' },
      { email: 'test@gmail.com', phone: '1522229999' }
    ]
  };

  const rowReward1 = {
    reward: 'Rewards 1',
    quantity: 100,
    date: '27/05/2021',
    account: 'ADFHWIDHQOFHSHDAKJHF'
  };

  const rowReward2 = {
    reward: 'Rewards 2',
    quantity: 200,
    date: '27/05/2021',
    account: 'ADFHWIDHQOFHSHDAKJHFWQHIOWOIDWQFWQDUBQWKUCBWQBEDUWFQWDVWQUCVWQO'
  };
  let itemSubtotal = 0;
  let totalVat = 0;
  let orderTotal = 0;


  // eslint-disable-next-line class-methods-use-this
  data.lineItems.forEach((el: any) => {
    itemSubtotal += el.sensorsQuantity * el.sensorsPrice;
    totalVat += el.sensorsVat;
  });
  orderTotal += itemSubtotal + totalVat;

  const orderData = {
    name: data.name,
    orderNumber: data.orderId,
    paymentMethod: data.paymentType,
    dateOrder: data.date,
    ecommerce: 'PlanetWatch.io', // Hardcoded?
    totalPrice: {
      itemSubtotal,
      totalVat,
      orderTotal
    },
    billing: data.billingAddress,
    shippingInfo: [
      rowShippingInfo1,
      rowShippingInfo2
    ],
    items: data.lineItems,
    rewards: [
      rowReward1,
      rowReward2
    ]
  };

  return (
        <div className='fullPopup text-white mx-auto d-flex flex-column justify-content-center' >
            <OrderHeader orderData={orderData}/>
            <OrderTable orderData={orderData}/>
        </div>
  );
};

export default OrderDetails;
export type {
  IOrder,
  IAddPurchaseState
};